
import {Prop} from 'vue-property-decorator';
import {Options, Vue} from 'vue-class-component';
import vueRecaptcha from 'vue3-recaptcha2';
import axios from "axios";


@Options({
  components: {vueRecaptcha},
})

export default class ContactForm extends Vue {
  @Prop({default: null}) private firstNameLabel?: string | null;
  @Prop({default: null}) private lastNameLabel?: string | null;
  @Prop({default: null}) private phoneLabel?: string | null;
  @Prop({default: null}) private emailLabel?: string | null;
  @Prop({default: null}) private messageLabel?: string | null;
  @Prop({default: null}) private gdprText?: string | null;
  @Prop({default: null}) private buttonLabel?: string | null;
  @Prop({default: null}) private successMessage?: string | null;
  @Prop({default: null}) private errorMessage?: string | null;
  @Prop({default: null}) private formType?: string | null;
  @Prop({default: "inline"}) private formAppearance?: string;
  @Prop({default: null}) private lang?: string | null;
  @Prop({default: null}) private origin?: string | "";
  @Prop({default: ""}) private baseUrl?: string | "";
  @Prop({default: ""}) private endpoint?: string | "";
  private endpointUri?: string | "";
  private showRecaptcha: boolean = true;
  private siteKey: string = "6LcxyrIUAAAAAJyS1tP_SN5zeRxxM8Bk3VEqdv3Z";
  private token: string = "";
  private notification: string = "";
  private notificationClass: string = "";
  private captchaValid: boolean = false;

  beforeMount() {
    this.endpointUri = this.baseUrl! + this.endpoint!;

  }

  mounted() {
    if(this.formAppearance === "full") {
      const firstName = this.$refs.firstName as HTMLInputElement;
      const lastName = this.$refs.lastName as HTMLInputElement;
      const phone = this.$refs.phone as HTMLInputElement;
      const email = this.$refs.email as HTMLInputElement;
      const message = this.$refs.message as HTMLInputElement;


      firstName.placeholder = this.firstNameLabel as string + "*";
      lastName.placeholder = this.lastNameLabel as string + "*";
      phone.placeholder = this.phoneLabel as string + "*";
      email.placeholder = this.emailLabel as string + "*";
      message.placeholder = this.messageLabel as string + "*";
    }
  }

  beforeUpdate() {
    const form = this.$refs.form as HTMLFormElement;
    const validationPassed = form.checkValidity();
    console.log('before update '+ validationPassed);
  }

  private recaptchaVerified(res: any) {
    this.token = res as string;
    this.captchaValid = true;
  }

  private recaptchaExpired() {
    const recaptcha = this.$refs.vueRecaptcha as any;
    recaptcha.reset();
    this.captchaValid = false;
  }

  private recaptchaFailed() {
  }

  private clearForm(): void {
    const firstName = this.$refs.firstName as HTMLInputElement;
    const lastName = this.$refs.lastName as HTMLInputElement;
    const phone = this.$refs.phone as HTMLInputElement;
    const email = this.$refs.email as HTMLInputElement;
    const message = this.$refs.message as HTMLInputElement;
    const checkbox = this.$refs.checkbox as HTMLInputElement;
    const recaptcha = this.$refs.vueRecaptcha as any;
    const submitBtn = this.$refs.submitButton as HTMLButtonElement;

    firstName.value = "";
    lastName.value = "";
    phone.value = "";
    email.value = "";
    message.value = "";
    checkbox.checked = false;

    recaptcha.reset();
    this.captchaValid = false;
    submitBtn.setAttribute('disabled','disabled');


  }


  private toggleSubmitBtn(): void {
    const currentForm = this.$refs.form as HTMLFormElement;
    const submitBtn = this.$refs.submitButton as HTMLInputElement;

    if(this.captchaValid && currentForm.checkValidity()) {
      submitBtn.removeAttribute('disabled');
    } else {
      submitBtn.setAttribute('disabled','disabled');
    }
  }

  private handleRequest(): Promise<any> {
    const httpRequest = axios.create({
      baseURL: this.baseUrl,      
      headers: {'Application-Type': 'application/json'}
    });

    const firstName = this.$refs.firstName as HTMLInputElement;
    const lastName = this.$refs.lastName as HTMLInputElement;
    const phone = this.$refs.phone as HTMLInputElement;
    const email = this.$refs.email as HTMLInputElement;
    const message = this.$refs.message as HTMLInputElement;
    const checkbox = this.$refs.checkbox as HTMLInputElement;

    return httpRequest.post(this.endpoint!, {
      firstName: firstName.value,
      lastName: lastName.value,
      telephone: phone.value,
      email: email.value,
      message: message.value,
      recaptchaToken: this.token,
      gdpr: checkbox.checked,
      formType: this.formType,
      origin: this.origin,
      language: this.lang
    });
  }

  private handleNotification(success: boolean): void {
    const notification = this.$refs.notificationHolder as HTMLElement;
    notification.classList.remove("contact-form__notification--success");
    notification.classList.remove("contact-form__notification--error");

    if (success) {
      this.notification = this.successMessage as string;
      notification.classList.add("contact-form__notification--success");
    } else {
      this.notification = this.errorMessage as string;
      notification.classList.add("contact-form__notification--error");
    }
  }

  private handleSubmit(): void {
    const form = this.$refs.form as HTMLFormElement;
    if (!form.checkValidity()){
      this.handleNotification(false);
      form.classList.add("validation");
      return;
    }

    this.handleRequest()
        .then((res) => {
          console.log(res);
          if (res.status === 200) {

            this.clearForm();
            this.handleNotification(true);
            const currentForm = this.$refs.form as HTMLFormElement;

            currentForm.classList.remove('validation');
          }
        })
        .catch(() => {
          const recaptcha = this.$refs.vueRecaptcha as any;
          recaptcha.reset();
          this.handleNotification(false);
        });
  }


}

